import {
  Accordion,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Group,
  Image,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { AxiosResponse, isAxiosError } from 'axios';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DirectionDownIcon, PrepareOrder } from '../../assets';
import { customLoader } from '../../components/CustomLoader';
import NoDataFound from '../../components/NoDataFound';
import { toastSuccess } from '../../config/Helper';
import { ROUTES } from '../../config/RoutesName';
import { useSideBarStyle } from '../../layout/components/Style';
import { orderDetails } from '../../services/order/order.service';
import { receiptOtpRequest } from '../../services/receipt/receipt.service';
import { IBaseResponseError } from '../../typescript/interfaces/common.interface';
import { IOrderDetails } from '../../typescript/interfaces/order-interface';
import { buttonStyle } from '../../utils/styles/GlobalStyle';
import { ModalCloseButton } from '../Cart/style';
import CancelReason from './components/CancelReason';
import Review from './components/Review';
import { useOrderStyle } from './style';

const OrderDetails = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const [openedPeparing, { open: openPeparing, close: closePeparing }] = useDisclosure(false);
  const { classes } = useOrderStyle();
  const { classes: sidebarClass } = useSideBarStyle();
  const { classes: buttonClass } = buttonStyle();
  const { classes: closeButtonStyle } = ModalCloseButton();
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  //my code
  const { orderId } = useParams<{ orderId: string }>();
  const [shouldRefetch, setShouldRefetch] = useState(true);
  // const shouldReftchRef = useRef(true);
  const { data: getOrderDetails, isLoading, isSuccess, isFetching } = orderDetails(orderId, shouldRefetch);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (getOrderDetails && [3, 6].includes(getOrderDetails?.status?.id ?? 0) && !isFetching)
      // shouldReftchRef.current = false;
      setShouldRefetch(false);
  }, [getOrderDetails, isFetching]);

  const viewReceipt = async () => {
    setLoading(true);
    try {
      const data = await receiptOtpRequest(orderId);
      if (data.success) {
        toastSuccess(data.message);
        setLoading(false);
        navigate(ROUTES.PHONEVERIFY, {
          state: {
            name: getOrderDetails?.user.name,
            contactType: getOrderDetails?.user.email ? 'email' : 'phone',
            userEmail: getOrderDetails?.user.email,
            userPhone: getOrderDetails?.user.phone_number,
            verifyToken: orderId,
          },
        });
      }
    } catch (error: unknown) {
      console.log(error);
      if (isAxiosError(error)) {
        const response = error.response as AxiosResponse<IBaseResponseError> | undefined;
        const data = response?.data;
        const hasApiError = data?.data?.error_type && data?.data?.error_message;
        // toastError(hasApiError ? data : data?.message);
      }
      setLoading(false);
    }
  };

  const buttonInfo = useMemo(() => {
    if (getOrderDetails && orderId) {
      switch (getOrderDetails?.status.id) {
        case 1:
        case 2:
          return {
            label: 'Cancel',
            action: open,
          };
        case 3:
          return {
            label: 'Go Home',
            action: () => navigate(ROUTES.HOME),
          };
        case 4:
          return {
            label: 'Cancel',
            action: openPeparing,
          };
        default:
          return {
            label: 'View Receipt',
            action: viewReceipt,
          };
      }
    }
  }, [getOrderDetails, orderId]);

  return (
    <>
      <LoadingOverlay loader={customLoader} visible={isLoading} />
      {isSuccess ? (
        <>
          <Box
            w={window.innerWidth / 2 - 45}
            className={getOrderDetails.amount ? sidebarClass.cornerSideWrapper : sidebarClass.cornerWrapper}></Box>
          <Container>
            <Grid m={0} fw={500}>
              <Grid.Col span={6} p={0}>
                <Text fz='16px' fw={500} color='black' ta={'left'}>
                  ORDER STATUS
                </Text>
                <Text fz={'16px'} color='red' ta={'left'} pt={'md'}>
                  Order #{getOrderDetails.token}
                </Text>
              </Grid.Col>
            </Grid>
            {typeof getOrderDetails?.status.id !== 'undefined' ? (
              <>
                <Text fz={'20px'} fw={500} color='#FA9418' pt={'5px'} pos='absolute' ta={'left'}>
                  {getOrderDetails?.status.name}
                </Text>

                {getOrderDetails?.status.id === 3 && (
                  <Box pos='relative' top={45}>
                    <Text color='red' fw={500} fz={mobile ? '12px' : '14px'}>
                      Cancel Reason
                    </Text>

                    <Box mt={10}>
                      {getOrderDetails?.status.cancel_reason?.reason === 'Other' && (
                        <Text fz={'16px'} fw={500} color='dark.9' ta={'left'}>
                          {getOrderDetails?.status.cancel_reason?.comment}(
                          {getOrderDetails?.status.cancel_reason?.reason})
                        </Text>
                      )}
                      {(getOrderDetails as IOrderDetails)?.status.cancel_reason?.reason !== 'Other' && (
                        <Text fz={'16px'} fw={500} color='dark.9' ta={'left'}>
                          {(getOrderDetails as IOrderDetails)?.status.cancel_reason?.reason}
                        </Text>
                      )}
                    </Box>
                  </Box>
                )}

                {getOrderDetails?.status.id === 6 ? (
                  <Review />
                ) : (
                  <Group
                    position='center'
                    pt={'20px'}
                    pos='relative'
                    style={{
                      zIndex: -1,
                    }}>
                    <Image src={PrepareOrder} width='auto' height='auto' />
                  </Group>
                )}
              </>
            ) : null}

            <ScrollArea.Autosize type='never' mah={window.innerHeight - 90}>
              <Box pt={'35px'} pb={'10px'} fw={500} ta='left'>
                <Text color='red' fz={mobile ? '12px' : '14px'}>
                  Ordered By
                </Text>
                <Text color='black' fz={'20px'} pt={5}>
                  {getOrderDetails.user.name}
                </Text>

                <Text color='red' fz={mobile ? '16px' : '17px'} pt={3}>
                  {getOrderDetails?.payment_status?.name}
                </Text>
                {String(getOrderDetails?.paid_at)?.toLowerCase() !== 'none' && (
                  <Text fz={mobile ? '12px' : '14px'} color={'black'}>
                    on {getOrderDetails?.paid_at}
                  </Text>
                )}
              </Box>
              <Divider my='sm' />
              {/* <Box pt={'5px'} ta='left'>
                {getOrderDetails?.details?.items?.length ? (
                  getOrderDetails?.details?.items?.map((item, index) => (
                    <React.Fragment key={index}>
                      <Text fw={500} fz={'16px'} pb='md' color='black'>
                        {item?.quantity} X {item?.name}
                      </Text>
                      {item?.addons?.length ? (
                        <Accordion
                          chevronPosition='right'
                          chevronSize={50}
                          variant='filled'
                          chevron={<DirectionDownIcon />}
                          transitionDuration={500}
                          defaultValue={item?.name}
                          classNames={classes}>
                          <Accordion.Item value={item?.name}>
                            <Accordion.Control p={0}>
                              <Text fw={500} size={mobile ? '12px' : '14px'} color='red'>
                                Add Ons
                              </Text>
                            </Accordion.Control>
                            <Accordion.Panel>
                              {item?.addons?.map((element, elId) => (
                                <Text key={elId} fw={450} fz={mobile ? '11px' : '13px'} pt='16px' color='black'>
                                  {element?.item_choice}
                                </Text>
                              ))}
                            </Accordion.Panel>
                          </Accordion.Item>
                        </Accordion>
                      ) : (
                        <>{''}</>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <NoDataFound text='No item found.' />
                )}
              </Box> */}

              <Box pt={'5px'} ta='left'>
                {getOrderDetails?.details?.items?.length ? (
                  getOrderDetails?.details?.items?.map((item, index) => (
                    <React.Fragment key={index}>
                      {/* ITEM HEADER */}
                      <Group position='apart'>
                        <Text fw={500} fz={'16px'} pb='xs' color='black'>
                          {item?.quantity} X {item?.name} &nbsp;
                          <Text component='span' fz='13px' color='dimmed'>
                            (Calories: {item?.calories})
                          </Text>
                        </Text>
                        <Text fw={600} fz='14px'>
                          ${item?.price}
                        </Text>
                      </Group>

                      {/* ADDONS */}
                      {item?.addons?.length ? (
                        <Accordion
                          chevronPosition='right'
                          chevronSize={50}
                          variant='filled'
                          chevron={<DirectionDownIcon />}
                          transitionDuration={500}
                          defaultValue={item?.name}
                          classNames={classes}>
                          <Accordion.Item value={item?.name}>
                            <Accordion.Control p={0}>
                              <Text fw={500} size={mobile ? '12px' : '14px'} color='red'>
                                Add Ons
                              </Text>
                            </Accordion.Control>

                            <Accordion.Panel>
                              {item?.addons?.map((element, elId) => (
                                <Group key={elId} position='apart' pt='10px'>
                                  <Text fw={450} fz={mobile ? '11px' : '13px'} color='black'>
                                    {element?.item_choice} ({element?.addon_level})
                                  </Text>
                                  <Text fz='12px' fw={600} color='dimmed'>
                                    ${element?.amount}
                                  </Text>
                                </Group>
                              ))}
                            </Accordion.Panel>
                          </Accordion.Item>
                        </Accordion>
                      ) : null}

                      <Divider my='sm' />
                    </React.Fragment>
                  ))
                ) : (
                  <NoDataFound text='No item found.' />
                )}

                {/* TOTAL SUMMARY */}
                <Box pt='10px'>
                  {/* <Divider my='sm' /> */}
                  <Group position='apart' mb={10}>
                    <Text fz='14px'>Items Total</Text>
                    <Text fw={600} fz='14px'>
                      ${getOrderDetails?.details?.price?.food_items_amount}
                    </Text>
                  </Group>
                  <Group position='apart' mb={10}>
                    <Text fz='14px'>Discount</Text>
                    <Text fz='14px'>${getOrderDetails?.details?.price?.coupon_discount}</Text>
                  </Group>
                  <Group position='apart'>
                    <Text fz='14px'>Tax amount</Text>
                    <Text fz='14px'>
                      $
                      {(
                        getOrderDetails?.details?.price?.amount_with_tax - getOrderDetails?.details?.price?.total_amount
                      ).toFixed(2)}
                    </Text>
                  </Group>
                  <Divider my='sm' />
                  <Group position='apart' mt='5px'>
                    <Text fw={600} fz='16px'>
                      Grand Total
                    </Text>
                    <Text fw={600} fz='16px' color='red'>
                      ${getOrderDetails?.details?.price?.amount_with_tax}
                    </Text>
                  </Group>
                </Box>
              </Box>

              <Group pt='20px' pb='5px' position='center' bg='white' className={classes.buttonSticky}>
                {/* {![4, 3]?.includes(getOrderDetails?.status.id) && ( */}
                <Button
                  w='50%'
                  radius={'11px'}
                  h='60px'
                  fz={'16px'}
                  maw='250px'
                  variant={getOrderDetails?.status.id === 1 ? 'outline' : 'filled'}
                  color='red'
                  className={buttonClass.buttonShadow}
                  loading={loading}
                  onClick={buttonInfo?.action}
                  // onClick={getOrderDetails?.status.id === 1 ? open : viewReceipt}
                >
                  {/* {getOrderDetails?.status.id === 1 ? 'Cancel' : 'View Receipt'} */}
                  {/* {getOrderDetails?.status.id < 3 && 'Cancel'}
                    {getOrderDetails?.status.id >= 5 && 'View Receipt'} */}
                  {buttonInfo?.label}
                </Button>
                {/* )} */}

                {/* {getOrderDetails?.status.id === 3 && (
                  <Button
                    w='50%'
                    radius={'11px'}
                    h='60px'
                    fz={'16px'}
                    maw='250px'
                    variant='filled'
                    color='red'
                    className={buttonClass.buttonShadow}
                    loading={loading}
                    onClick={() => navigate(ROUTES.HOME)}>
                    Go Home
                  </Button>
                )} */}
              </Group>
            </ScrollArea.Autosize>

            <Modal
              classNames={classes}
              className={closeButtonStyle.closeButton}
              opened={opened}
              onClose={close}
              title='Cancel Order'
              centered>
              <CancelReason modalClose={close} />
            </Modal>
            {/* Peparing Order Modal */}
            <Modal
              classNames={classes}
              className={closeButtonStyle.closeButton}
              opened={openedPeparing}
              onClose={closePeparing}
              title='Cancel Order'
              centered>
              Order is getting prepared, you can't cancel right now.
            </Modal>
          </Container>
        </>
      ) : null}
    </>
  );
};

export default OrderDetails;
